<template>
  <div id="tree-back">
    <div class="v-align">
      <div
        class="layer"
        v-for="(layer, index) in layers"
        :style="{ height: `${height / layers.length}px` }"
        :data-color="layer[0][0].group"
        :data-node-selected="index === layerSelected"
      >
        <div class="block">
          <div class="bar">
            <svg viewBox="0 0 17 17" preserveAspectRatio="none">
              <polygon points="0,0 17,8.5 0,17 "/>
            </svg>
          </div>
          <div class="number"></div>
          <div class="name">{{levelNames[layer[0][0].nivel]}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import EventSystem from '../utils/EventSystem';

  export default {
    props: {
    },
    data() {
      return {
        layers: [],
        height: 0,
        layerSelected: -1,
        levelNames: ['' ,'????', '????', '????', '????', '????', '????', '????', '????', '????', '????', '????', '????', '????'],
      };
    },
    created() {
      EventSystem.$on('tree-view-data', data => {
        if (data.layers[0][0][0].front.match(/universidades?/gi)) {
          this.levelNames = ['', 'Aprendiz', 'Estagiário', 'Auxiliar', 'Assistente / Operacional', 'Analista', 'Encarregado', 'Supervisor', 'Coordenador/Especialista', 'Gerente', 'Diretor Adjunto', 'Diretor', 'Superintendente', 'Presidência e Vice-Presidência'];
        } else {
          this.levelNames = ['', 'Aprendiz', 'Estagiário', 'Auxiliar', 'Assistente / Operacional', 'Analista', 'Encarregado', 'Supervisor', 'Coordenador/Especialista', 'Gerente', 'Diretor Adjunto', 'Diretor', 'Superintendente', 'Presidência e Vice-Presidência'];
        }

        this.layers = data.layers.reverse();
        this.height = data.height;
        this.layerSelected = this.layers.length - 1;
      });

      EventSystem.$on('tree-view-close', () => {
        this.layers = [];
      });

      EventSystem.$on('tree-view-node-click', node => {
        this.layers.forEach((layer, index) => {
          layer.forEach(subLayer => {
            const find = subLayer.find(n => n.id === node.id)

            if (find) {
              this.layerSelected = index;
            }
          });
        });
      });
    },
    computed: {
    },
    methods: {
    },
  };

</script>



// WEBPACK FOOTER //
// assets/js/source/vue-ui/tree-back.vue